"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATS_PERIODS = void 0;
exports.STATS_PERIODS = ['1W', '1M', '3M', '6M', 'YTD', 'ALL_TIME'];
